import React from "react";
import { EditorBlock } from "draft-js";
export default class TableBlock extends React.Component {
  render() {
    let data = this.props.block.getData().toJS() || {};
    let table = data.table || [];
    let classes = [];
    for (let k in data) {
      classes.push(`editor-block-data-${k}-${data[k]}`);
    }

    return (
      <div className="editor-table-block">
        <table className="w-100">
          <tbody>
            {table.map((row, index) => {
              return (
                <tr key={`${data.key}${index}`}>
                  {row.map((col) => {
                    return (
                      <td
                        className={` 
                               editor-table-cell
                            ${
                              data.align &&
                              col.self &&
                              `editor-block-align-${data.align}`
                            }                  
                            ${
                              col.borderLeft
                                ? "editor-table-cell-border-left"
                                : ""
                            }
                            ${
                              col.borderRight
                                ? "editor-table-cell-border-right"
                                : ""
                            } 
                            ${
                              col.borderTop
                                ? "editor-table-cell-border-top"
                                : ""
                            }
                            ${
                              col.borderBottom
                                ? "editor-table-cell-border-bottom"
                                : ""
                            }
                            ${
                              col.padding
                                ? `editor-table-cell-padding-${col.padding}`
                                : ""
                            }
                             
                        `}
                        key={`${data.key}${col.key}`}
                        id={`editor-table-cell-${col.key}`}
                        style={{
                          backgroundColor: col.backgroundColor,
                          width: col.width && `${col.width}%`,
                          verticalAlign: col.verticalAlign,
                        }}
                      >
                        {col.self && (
                          <div className={`editor-block ${classes.join(" ")}`}>
                            <EditorBlock
                              className={classes.join(" ")}
                              {...this.props}
                            />
                          </div>
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
